import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  usePendingFitmentSkusQuery,
  useRejectPendingProvisionMutation,
} from "../api/queries";
import { CatalogPendingFitmentTable } from "../ui/CatalogPendingFitmentTable";

type PendingFitmentSearch = {
  limit?: number;
  offset?: number;
};

export function CatalogPendingFitmentPage() {
  const nav = useNavigate({ from: "/app/catalog/pending-fitment" });
  const search = useSearch({
    from: "/app/catalog/pending-fitment",
  }) as PendingFitmentSearch;

  const list = usePendingFitmentSkusQuery({
    limit: search.limit ?? 20,
    offset: search.offset ?? 0,
  });
  const rejectMutation = useRejectPendingProvisionMutation();
  const canReject = useActionPermission(["catalog:delete"]);

  const data = list.data?.data ?? [];
  const meta = list.data?.meta ?? { total: 0, limit: 20, offset: 0 };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Catalog", to: "/app/catalog" },
            { label: "ຄິວ fitment ລໍຖ້າ" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h1 className="font-bold text-2xl tracking-tight">ຄິວ fitment ລໍຖ້າ</h1>
          <p className="mt-1 text-muted-foreground text-sm">
            SKU ຈາກ POS provision ຫຼື catalog ທີ່ຍັງບໍ່ມີ fitment — ຄີ fitment ≥ 1
            ເພື່ອ publish marketplace (auto-publish ເມື່ອຮ້ານເປີດ flag)
          </p>
        </div>

        <div className="rounded-xl border bg-card pt-2">
          <CatalogPendingFitmentTable
            isLoading={list.isLoading}
            data={data}
            offset={meta.offset}
            limit={meta.limit}
            totalCount={meta.total}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            canReject={canReject}
            onReject={async (catalogSkuId) => {
              await rejectMutation.mutateAsync(catalogSkuId);
              await list.refetch();
            }}
          />
        </div>
      </Main>
    </>
  );
}
